import { storageUrl } from '../../../lib/api.js'
import { RiCloseLine, RiDeleteBinLine, RiEditLine, RiEyeLine, RiImageAddLine } from 'react-icons/ri'
import { Badge, Toggle } from '../../../components/ui/design.jsx'
import { kategoriColor, parseKat } from '../constants.js'

export default function KelasCard({ item, onPreview, onToggle, onEdit, onRemove }) {
  const kats = parseKat(item.kategori)
  const hasImage = item.thumb_url || item.image_url

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md hover:border-blue-300 transition-all">
      {/* Thumbnail */}
      <div className="relative aspect-video cursor-pointer bg-gray-100" onClick={() => onPreview(item)}>
        {hasImage ? (
          <img
            src={storageUrl(item.thumb_url || item.image_url)}
            alt={item.title}
            className="h-full w-full object-cover"
            onError={(e) => { e.currentTarget.src = storageUrl(item.image_url) }}
            loading="lazy"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-gray-300">
            <RiImageAddLine className="text-3xl" />
          </div>
        )}
        <span className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-lg bg-black/60 px-2 py-1 text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity backdrop-blur-sm">
          <RiEyeLine /> Lihat
        </span>
        {kats.length > 0 && (
          <div className="absolute left-2 bottom-2 flex flex-wrap gap-1">
            {kats.map((k) => (
              <Badge key={k} className={kategoriColor(k)}>{k}</Badge>
            ))}
          </div>
        )}
      </div>

      {/* Info */}
      <div className="px-4 py-3">
        <div className="text-sm font-semibold text-gray-900 truncate">{item.title}</div>
        <div className="mt-1 text-xs text-gray-400">Rating: {item.rating}</div>
        <div className="mt-2 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Toggle checked={item.is_active} onChange={() => onToggle(item)} size="sm" />
            <span className="text-xs text-gray-400">{item.is_active ? 'Aktif' : 'Nonaktif'}</span>
          </div>
          <div className="flex gap-1">
            <button onClick={() => onEdit(item)} className="rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-colors" title="Edit">
              <RiEditLine />
            </button>
            <button onClick={() => onRemove(item)} className="rounded-lg p-1.5 text-gray-400 hover:bg-red-50 hover:text-red-600 transition-colors" title="Hapus">
              <RiDeleteBinLine />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
